import { Fragment } from 'react';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const ErrorHandle = ({ error, message }) => (
  <Fragment>
    {error && <p className={global.ErrorMessage}>{message}</p>}
  </Fragment>
)
export default ErrorHandle;